export default __webpack_public_path__ + "static/media/set_3_Video-2.8bbaf592.svg";